import axios from 'axios';

export default axios.create({
    baseURL: process.env.REACT_APP_CAMP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});